// import { createSelector } from '@reduxjs/toolkit';
// Types
import Reducers from 'app/types/Reducers';
// Models
import { RootState } from 'app/store';

export const selectRequestStatusCode = (state:RootState) => state[Reducers.AppUIStatus].requestStatusCode;
